import formatTokenKeys from '../consts/app/formatTokenKeys';
import stringUtils from '../utils/stringUtils';
import languageService from './localization/languageService';

const getLanguageFormattedString = (str) => {
    const language = languageService.getCurrentLanguageCode();

    return formatStringWithLanguage(str, language?.toLowerCase());
};

const formatStringWithLanguage = (str, language) =>
    stringUtils.formatByName(str, {[formatTokenKeys.CULTURE_CODE]: language});

export default {getLanguageFormattedString, formatStringWithLanguage};
